import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-emerald-900 text-emerald-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap font-heading text-lg font-extrabold text-white">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-emerald-500 text-white">
                <i className="ri-stack-line"></i>
              </span>
              <span>USFansLink</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-emerald-100/80">
              {t('footer.tagline')}
            </p>
            <div className="mt-5">
              <LanguageSwitcher light />
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white">
              {t('footer.quickLinks')}
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/article" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('nav.article')}
                </Link>
              </li>
              <li>
                <a href="#categories" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('nav.categories')}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('nav.faq')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white">
              {t('footer.categories')}
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="whitespace-nowrap text-emerald-100/80 transition-colors hover:text-white"
                  >
                    {t(`categories.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wide text-white">
              {t('footer.resources')}
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="#trust" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('footer.about')}
                </a>
              </li>
              <li>
                <a href="#trust" className="text-emerald-100/80 transition-colors hover:text-white">
                  {t('footer.safety')}
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-emerald-100/80 transition-colors hover:text-white"
                >
                  {t('cta.visitMain')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-emerald-800 pt-8">
          <p className="text-xs leading-relaxed text-emerald-100/60">
            {t('footer.disclaimer')}
          </p>
          <div className="mt-4 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <p className="text-xs text-emerald-100/60">
              © {new Date().getFullYear()} USFansLink.wiki — {t('footer.rights')}
            </p>
            <p className="text-xs text-emerald-100/60">
              {t('footer.disclaimerLink')} · {t('footer.safety')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}